import React, { Component, Fragment } from "react";
import "../../Styles/Pages/table.scss";
import ContentLoader from "react-content-loader";
import Checkbox from "../../../src/Resources/Forms/Checkbox";
import { _sortArray, _cloneArray } from "../../../src/Utils/helpers";
import ViewMore from "../../../src/Resources/ViewMore";
import EmptyState from "../../Accounts/EmptyState";
import TableItem from "./TableItem";
import withScreenType from "../../HOC/withSceenType";

class Table extends Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
    this.state = {
      remainingWidth: "14px",
      remainingRatioCount: this.props.headings ? this.props.headings.length : 1,
      sliceValue: this.props.sliceValue || 10,
      activeSort: "",
      fields: [],
      columns: [],
      tableKey: "",
    };
  }

  componentDidMount() {
    if (this.props.headings.length > 0) {
      this.getRemainingWidth();
      this.getRemainingRationCount();
    }
    if (this.props.fields) {
      this.setState({ fields: this.props.fields });
    }
    if (this.props.columns) {
      this.createTableColumns();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fields !== this.props.fields) {
      this.setState({ fields: this.props.fields });
    }
    if (prevProps.columns !== this.props.columns) {
      this.createTableColumns();
    }
    if (prevProps.sliceValue !== this.props.sliceValue) {
      this.setState({ sliceValue: this.props.sliceValue });
    }
  }

  render() {
    return (
      <Fragment>
        <Fragment>
          {this.props.goBack && (
            <div className="bo-data-table-heder">
              <div>
                <img
                  src="Images/dark-back.svg"
                  alt=""
                  className={"report-back-link"}
                  onClick={this.props.goBack}
                />
              </div>
              <span>{this.props.headerText}</span>
            </div>
          )}
          {this.props.tableTop && (
            <div className="bo-data-table-top show--desktop">
              {this.props.tableTop}
            </div>
          )}
          <span
            style={{
              opacity: 0,
              visibility: "hidden",
              height: "1px",
              overflow: "hidden",
              position: "fixed",
              top: 0,
            }}
            className="no-print"
          >
            {this.state.tableKey}
          </span>
          <div
            className={`bo-data-table ${
              this.props.showLoader ? "bo-data-table-loader" : ""
            } ${this.props.showHorizontalScroll ? "overflow-table" : ""}`}
            style={{ minHeight: this.props.minHeight || "" }}
          >
            {this.props.tableInfo && (
              <div
                className={`bo-data-table-info ${
                  !this.props.showTableInfoOnMobile ? "show--desktop" : ""
                }`}
              >
                {this.props.tableInfo}
              </div>
            )}
            {this.props.showLoader ||
            !this.props.fields ||
            (this.props.fields && this.props.fields.length > 0) ? (
              <Fragment>
                <div
                  className={`${
                    this.props.showHorizontalScroll ? "overflow-table" : ""
                  }`}
                >
                  <div
                    className="bo-data-table-header show--desktop"
                    style={{
                      borderBottom: this.props.tableInfo
                        ? "1px solid #f1f1f1"
                        : "",
                      top: this.props.headerTop || "",
                    }}
                  >
                    {this.props.showHeaderCheckbox && (
                      <div className="bo-data-table-header-checkbox">
                        <Checkbox
                          padding={"0px"}
                          checked={this.props.isHeaderCheckboxChecked}
                          onChange={this.props.checkAllItems}
                        />
                        <img
                          src="Images/downarrow.svg"
                          alt=""
                          onClick={() =>
                            this.setState({
                              showCheckedAllDropdown: true,
                            })
                          }
                        />
                      </div>
                    )}
                    {this.props.headings &&
                      this.props.headings.map((heading, i) => (
                        <div
                          className={`bo-data-table-header-item ${
                            heading.classNames || ""
                          }`}
                          key={i}
                          style={{
                            fontSize: this.props.smallHeaderText
                              ? "11px"
                              : "12px",
                            width:
                              this.props.screenType === "mobile"
                                ? ""
                                : heading.width
                                ? heading.width + "px"
                                : this.props.showHorizontalScroll
                                ? this.getColumnWidth(i) + "px"
                                : `calc(100% - ${this.state.remainingWidth})`,
                            minWidth: heading.width
                              ? heading.width - 7 + "px"
                              : this.props.showHorizontalScroll
                              ? this.getColumnWidth(i) - 7 + "px"
                              : "",
                          }}
                          onClick={() =>
                            this.props.sort && heading.text
                              ? this.props.sort(heading.text)
                              : this.state.fields.length > 0 &&
                                this.state.columns.length > 0 &&
                                !this.props.hideSort
                              ? this.sortTable(i)
                              : null
                          }
                        >
                          {this.props.showLoader ? (
                            <div>
                              <ContentLoader
                                height={300}
                                width={40}
                                speed={2}
                                primaryColor="#f3f3f3"
                                secondaryColor="#ecebeb"
                              >
                                <rect
                                  x="0"
                                  y="0"
                                  rx="0"
                                  ry="0"
                                  width="40"
                                  height="300"
                                />
                              </ContentLoader>
                            </div>
                          ) : (
                            <div
                              className={`${
                                heading.position === "center"
                                  ? "center-item"
                                  : ""
                              }`}
                            >
                              <span>{heading.text}</span>
                              {!this.props.hideSort && (
                                <Fragment>
                                  {(this.props.sort ||
                                    (this.state.fields.length > 0 &&
                                      this.state.columns.length > 0)) &&
                                    heading.text && (
                                      <span className="no-print bo-data-table-header-item-sorticon">
                                        <img
                                          src="Images/sort-table-icon.svg"
                                          alt=""
                                        />
                                      </span>
                                    )}
                                </Fragment>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    {this.props.subMenuOptions &&
                      this.props.subMenuOptions.length > 0 && (
                        <div style={{ width: "30px", minWidth: "23px" }}></div>
                      )}
                    {this.props.showColumnButton &&
                      Object.keys(this.props.showColumnButton || {}).length >
                        0 && (
                        <div style={{ width: "80px", minWidth: "80px" }}></div>
                      )}
                  </div>
                  <div className="bo-data-table-body">
                    {!this.props.showLoader ? (
                      <Fragment>
                        {this.props.children ? (
                          this.props.children
                        ) : (
                          <Fragment>
                            {this.state.fields &&
                              this.state.fields
                                .slice(0, this.state.sliceValue)
                                .map((field, i) => (
                                  <TableItem
                                    key={i}
                                    field={field}
                                    columns={this.state.columns}
                                    columnClick={this.props.columnClick}
                                    onColumnValueChange={
                                      this.props.onColumnValueChange
                                    }
                                    remainingWidth={this.state.remainingWidth}
                                    subMenuOptions={this.props.subMenuOptions}
                                    showColumnButton={
                                      this.props.showColumnButton
                                    }
                                    checkedRowIds={this.props.checkedRowIds}
                                    emptyColumnText={this.props.emptyColumnText}
                                    getColumnWidth={(index) =>
                                      this.getColumnWidth(index)
                                    }
                                    showColumnExpand={
                                      this.props.showColumnExpand
                                    }
                                    extraColumns={this.props.extraColumns}
                                    showHorizontalScroll={
                                      this.props.showHorizontalScroll
                                    }
                                    index={i}
                                    subMenuHideId={this.props.subMenuHideId}
                                    onCheckboxChange={
                                      this.props.onCheckboxChange
                                    }
                                    onSwitchChange={this.props.onSwitchChange}
                                    isMobile={
                                      this.props.screenType === "mobile"
                                    }
                                  />
                                ))}
                            {this.renderViewMore()}
                          </Fragment>
                        )}
                      </Fragment>
                    ) : (
                      [...Array(this.props.loaderCount || 10).keys()].map(
                        (_, i) => {
                          return (
                            <div className="bo-data-table-body-each" key={i}>
                              {this.props.headings.map((heading, i) => {
                                return (
                                  <div
                                    key={i}
                                    style={{
                                      width: heading.width
                                        ? heading.width + "px"
                                        : `calc(100% - ${this.state.remainingWidth})`,
                                      minWidth: heading.width
                                        ? heading.width - 7 + "px"
                                        : "",
                                    }}
                                  >
                                    <div>
                                      <ContentLoader
                                        height={300}
                                        width={40}
                                        speed={2}
                                        primaryColor="#f3f3f3"
                                        secondaryColor="#ecebeb"
                                      >
                                        <rect
                                          x="0"
                                          y="0"
                                          rx="0"
                                          ry="0"
                                          width="40"
                                          height="300"
                                        />
                                      </ContentLoader>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        }
                      )
                    )}
                  </div>
                  {this.props.tableFooter && (
                    <div className="bo-data-table__footer">
                      {this.props.tableFooter}
                    </div>
                  )}
                </div>
              </Fragment>
            ) : (
              <EmptyState
                text={this.props.emptyText || "No data found"}
                height={"100px"}
                margin={"100px auto"}
              />
            )}
          </div>
        </Fragment>
      </Fragment>
    );
  }

  getColumnWidth(index) {
    if (this.props.headings && this.props.headings.length > 0) {
      const headingText = this.props.headings[index].text;
      const availableWidth = window.screen.width - 340;
      const averageWidth = availableWidth / this.props.headings.length;
      if (averageWidth >= 200) {
        return averageWidth;
      }
      const width = headingText.length * 9 + 20;
      if (width > 300) {
        return 250;
      }
      if (width < 150) {
        return 150;
      }
      return width;
    }
    return 200;
  }

  getRemainingWidth = () => {
    let remainingWidth = 0;
    this.props.headings.forEach((heading) => {
      if (heading.width) {
        remainingWidth = remainingWidth + heading.width;
      }
    });
    if (remainingWidth > 0) {
      if (this.props.showHeaderCheckbox) {
        remainingWidth = remainingWidth + 55;
      }
      if (this.props.subMenuOptions && this.props.subMenuOptions.length > 0) {
        remainingWidth = remainingWidth + 30;
      }
      if (
        this.props.showColumnButton &&
        Object.keys(this.props.showColumnButton).length > 0
      ) {
        remainingWidth = remainingWidth + 55;
      }
      this.setState({ remainingWidth: remainingWidth + 30 + "px" }, () => {});
    }
  };

  getRemainingRationCount = () => {
    // let remainingRatios = this.props.headings.filter(heading => !heading.width);
    // this.setState({ remainingRatioCount: remainingRatios.length }, () => {});
  };

  sortTable = (index) => {
    let field = this.state.columns[index].text;
    let isNumber;
    if (
      this.props.fields &&
      this.props.fields.length > 0 &&
      this.props.fields[0][field] &&
      typeof this.props.fields[0][field] === "number"
    ) {
      isNumber = true;
    }
    const currentFields = _cloneArray(this.props.fields);
    let fields;
    if (field === this.state.activeSort) {
      this.setState(
        {
          isDescendingSort: !this.state.isDescendingSort,
        },
        () => {
          fields = _sortArray(
            currentFields,
            field,
            this.state.isDescendingSort
          );
          this.setState({ fields, activeSort: field });
        }
      );
    } else {
      this.setState(
        {
          isDescendingSort: isNumber ? true : false,
        },
        () => {
          fields = _sortArray(
            currentFields,
            field,
            this.state.isDescendingSort
          );
          this.setState({ fields, activeSort: field });
        }
      );
    }
  };

  reRenderTable = () => {
    this.setState({ tableKey: Math.random() });
  };

  createTableColumns = () => {
    if (!this.props.columns) {
      return;
    } else {
      if (this.props.columns.length === 0) {
        this.setState({ columns: [] });
        return;
      }
    }
    const columns = _cloneArray(this.props.columns);
    if (
      columns.length > 0 &&
      this.props.headings &&
      this.props.headings.length > 0
    ) {
      const headings = _cloneArray(this.props.headings).slice(
        0,
        columns.length
      );
      columns.forEach((_, index) => {
        if (headings[index]) {
          // columns[index].width = headings[index].width || "";
          columns[index].width = headings[index].width
            ? headings[index].width
            : columns[index].width || "";
        }
      });
    }
    this.setState({ columns });
  };

  loadMore = () => {
    if (this.props.viewMore) {
    } else {
      this.setState({
        sliceValue: this.state.sliceValue + 10,
      });
    }
  };

  renderViewMore = () => {
    let showViewMore;
    if (this.props.viewMore) {
      if (this.props.showViewMore) {
        return this.props.viewMore;
      }
      return null;
    } else {
      if (this.state.fields.length > this.state.sliceValue) {
        showViewMore = true;
      }
    }
    if (!showViewMore) {
      return null;
    }
    return (
      <ViewMore
        load={this.loadMore}
        margin={"20px auto 30px"}
        loadingMore={this.state.loadingMore}
      />
    );
  };
}

export default withScreenType(Table);
